import React from "react"

type ButtonVariant = "outlined" | "filled"

interface ActionButtonProps {
  href: string
  variant?: ButtonVariant
  children: React.ReactNode
  className?: string
  target?: string
  rel?: string
}

export const ActionButton: React.FC<ActionButtonProps> = ({
  href,
  variant = "outlined",
  children,
  className = "",
  target,
  rel,
}) => {
  const variantClass = variant === "filled" 
    ? "simple-page-button--filled" 
    : "simple-page-button--outlined"

  return (
    <a
      href={href}
      className={`simple-page-button ${variantClass} ${className}`}
      target={target}
      rel={rel}
    >
      {children}
    </a>
  )
}
